import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CityHero from '../../components/feature/CityHero';

export default function ReparationFenetreVenissieux() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <CityHero cityName="Vénissieux" />
      
      {/* Service Types Section */}
      <section id="services" className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* PVC Section */}
          <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
            <div className="relative h-96 rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/0aad6cdc2ec1b7a2e0b3baa917b48146.jpg"
                alt="Fenêtre PVC à Vénissieux"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Réparation Fenêtre PVC à Vénissieux</h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Nos experts interviennent rapidement pour tous vos problèmes de fenêtres PVC à Vénissieux. Que ce soit pour un remplacement de vitrage, une réparation de mécanisme ou un ajustement de l'étanchéité, nous garantissons un service professionnel et durable.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Réparation de mécanismes d'ouverture et fermeture</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Remplacement de joints d'étanchéité</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Changement de vitrage simple ou double</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Réglage et ajustement des ouvrants</span>
                </li>
              </ul>
              <a
                href="/reparation-fenetre-pvc-lyon"
                className="inline-flex items-center px-6 py-3 bg-teal-600 text-white font-medium rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                En savoir plus sur les fenêtres PVC
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>

          {/* Bois Section */}
          <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
            <div className="order-2 md:order-1">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Réparation Fenêtre Bois à Vénissieux</h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Spécialistes de la menuiserie bois, nous restaurons et réparons vos fenêtres en bois à Vénissieux avec le plus grand soin. Notre expertise permet de préserver le charme authentique de vos fenêtres tout en améliorant leurs performances.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start">
                  <i className="ri-check-line text-amber-600 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Traitement et protection du bois</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-amber-600 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Réparation de cadres et ouvrants</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-amber-600 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Remplacement de vitrages anciens</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-amber-600 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Restauration de fenêtres anciennes</span>
                </li>
              </ul>
              <a
                href="/reparation-fenetre-bois-lyon"
                className="inline-flex items-center px-6 py-3 bg-amber-600 text-white font-medium rounded-lg hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                En savoir plus sur les fenêtres bois
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
            <div className="relative h-96 rounded-2xl overflow-hidden shadow-xl order-1 md:order-2">
              <img
                src="https://readdy.ai/api/search-image?query=Traditional%20wooden%20window%20frame%20craftsmanship%20detail%20showing%20natural%20wood%20grain%20texture%20quality%20carpentry%20work%20classic%20design%20residential%20architecture%20warm%20tones%20simple%20clean%20background&width=800&height=600&seq=wood-window-venissieux-001&orientation=landscape"
                alt="Fenêtre Bois à Vénissieux"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Aluminium Section */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative h-96 rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://readdy.ai/api/search-image?query=Contemporary%20aluminum%20window%20frame%20modern%20architecture%20sleek%20metal%20finish%20minimalist%20design%20large%20glass%20panels%20urban%20residential%20building%20clean%20lines%20neutral%20background%20professional%20quality&width=800&height=600&seq=alu-window-venissieux-001&orientation=landscape"
                alt="Fenêtre Aluminium à Vénissieux"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Réparation Fenêtre Aluminium à Vénissieux</h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Nos techniciens maîtrisent parfaitement la réparation de fenêtres aluminium à Vénissieux. Robustes et modernes, vos fenêtres alu retrouveront leur fonctionnement optimal grâce à notre intervention rapide et professionnelle.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start">
                  <i className="ri-check-line text-gray-600 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Réparation de systèmes coulissants</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-gray-600 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Remplacement de joints et vitrages</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-gray-600 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Réglage de mécanismes oscillo-battants</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-gray-600 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Maintenance préventive</span>
                </li>
              </ul>
              <a
                href="/reparation-fenetre-alu-lyon"
                className="inline-flex items-center px-6 py-3 bg-gray-700 text-white font-medium rounded-lg hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                En savoir plus sur les fenêtres alu
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl lg:text-4xl font-extrabold text-gray-900 text-center mb-12">
            Nos Services à Vénissieux
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: 'ri-tools-line', title: 'Réparation Fenêtres PVC', desc: 'Remplacement de vitrage, joints, poignées' },
              { icon: 'ri-hammer-line', title: 'Réparation Fenêtres Alu', desc: 'Mécanismes, serrures, rails' },
              { icon: 'ri-paint-brush-line', title: 'Réparation Fenêtres Bois', desc: 'Restauration, traitement, peinture' },
              { icon: 'ri-window-line', title: 'Baies Vitrées', desc: 'Réparation et remplacement' },
              { icon: 'ri-lock-line', title: 'Quincaillerie', desc: 'Poignées, serrures, charnières' },
              { icon: 'ri-shield-check-line', title: 'Dépannage Urgent', desc: 'Intervention rapide 7j/7' }
            ].map((service, index) => (
              <div key={index} className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-100 hover:shadow-xl transition-all group">
                <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{service.title}</h3>
                <p className="text-gray-600">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl lg:text-4xl font-extrabold text-gray-900 text-center mb-12">
            Pourquoi Nous Choisir à Vénissieux ?
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: 'ri-time-line', title: 'Intervention Rapide', desc: 'Sous 24h à Vénissieux' },
              { icon: 'ri-shield-star-line', title: 'Garantie Qualité', desc: 'Travaux garantis 2 ans' },
              { icon: 'ri-money-euro-circle-line', title: 'Devis Gratuit', desc: 'Sans engagement' },
              { icon: 'ri-customer-service-2-line', title: 'Disponible 7j/7', desc: 'À votre écoute' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-gradient-to-br from-teal-50 to-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Demandez Votre Devis Gratuit à Vénissieux
            </h2>
            <p className="text-xl text-gray-600">
              Réponse personnalisée sous 24h
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <a href="tel:0980803684" className="flex flex-col items-center p-6 bg-teal-50 rounded-xl hover:bg-teal-100 transition-all cursor-pointer">
                <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mb-3">
                  <i className="ri-phone-line text-2xl text-white"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-1">Téléphone</h3>
                <p className="text-teal-600 font-medium">09 80 80 36 84</p>
              </a>

              <a href="mailto:info@fenetreslyon.fr" className="flex flex-col items-center p-6 bg-orange-50 rounded-xl hover:bg-orange-100 transition-all cursor-pointer">
                <div className="w-14 h-14 bg-orange-600 rounded-full flex items-center justify-center mb-3">
                  <i className="ri-mail-line text-2xl text-white"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-1">Email</h3>
                <p className="text-orange-600 font-medium">info@fenetreslyon.fr</p>
              </a>

              <Link to="/" className="flex flex-col items-center p-6 bg-gray-50 rounded-xl hover:bg-gray-100 transition-all cursor-pointer">
                <div className="w-14 h-14 bg-gray-600 rounded-full flex items-center justify-center mb-3">
                  <i className="ri-home-line text-2xl text-white"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-1">Accueil</h3>
                <p className="text-gray-600 font-medium">Retour au site</p>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
